"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightSpectrumToJSON = exports.LightSpectrumFromJSONTyped = exports.LightSpectrumFromJSON = exports.LightSpectrum = void 0;
/**
 * light spectrum used to record image. Usually only used for scanned images.
 * @export
 * @enum {string}
 */
var LightSpectrum;
(function (LightSpectrum) {
    LightSpectrum["VISIBLE"] = "VISIBLE";
    LightSpectrum["INFRARED"] = "INFRARED";
    LightSpectrum["ULTRAVIOLET"] = "ULTRAVIOLET";
})(LightSpectrum = exports.LightSpectrum || (exports.LightSpectrum = {}));
function LightSpectrumFromJSON(json) {
    return LightSpectrumFromJSONTyped(json, false);
}
exports.LightSpectrumFromJSON = LightSpectrumFromJSON;
function LightSpectrumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.LightSpectrumFromJSONTyped = LightSpectrumFromJSONTyped;
function LightSpectrumToJSON(value) {
    return value;
}
exports.LightSpectrumToJSON = LightSpectrumToJSON;
//# sourceMappingURL=LightSpectrum.js.map